module.exports = __webpack_public_path__ + "static/media/bang1.7ade32ec.mp3";